import React from 'react'
import { Tooltip } from 'antd'
import styled from 'styled-components'

import { colours } from '@qflow/theme'
import { icons } from 'portal/lib/primitives'
import { env } from 'portal/lib/config/env-config'

export function HelpLink() {
  const HELP_URL = `https://qualisflowhelp.zendesk.com/hc/en-gb/requests/new?v=${encodeURIComponent(env.CI_BUILDNUMBER)}`

  return (
    <HelpContainer>
      <Tooltip title={'Ask for help'} placement="bottom">
        <HelpAnchor
          href={HELP_URL}
          target="_blank"
          rel="noopener noreferrer nofollow"
          aria-label="Ask for help"
        >
          <icons.QuestionMark colour="currentColor" />
        </HelpAnchor>
      </Tooltip>
    </HelpContainer>
  )
}

const HelpAnchor = styled.a`
  display: flex;
  align-content: center;
  height: 40px;
  width: 40px;
  border: 1px solid ${colours.CORE_NAVY};
  border-radius: 20px;
  color: ${colours.CORE_NAVY};
  justify-content: center;
  align-items: center;

  &:hover,
  &:focus {
    color: ${colours.TEAL};
    background-color: ${colours.CONTROL_PANEL_GREY};
    border-color: ${colours.TEAL};
  }
`

const HelpContainer = styled.div`
  display: flex;
  flex: 0 0 auto;
  flex-direction: initial;
  align-items: center;
`
